<template>
  <div>
    <div>
      <button class="prev-btn mobile" @click="$emit('prev')" type="button">
        <img
          class="prev-icon"
          width="30"
          :src="require('../../assets/img/prev-icon-m.png')"
          alt="뒤로가기 아이콘"
        />
        이전 페이지
      </button>

      <span class="national-blue-bar sky"></span>
      <span class="national-blue-bar"></span>
      <div class="title-wrap">
        <div class="national-title">
          <span class="black">{{ sectedCongressman }} 국회의원</span> 미처리
          법안 목록
        </div>
        <div class="national-button-wrap">
          <button class="prev-btn pc" @click="$emit('prev')" type="button">
            <img
              class="prev-icon"
              :src="require('../../assets/img/prev-icon.png')"
              alt="뒤로가기 아이콘"
            />이전 페이지
          </button>
        </div>
      </div>
      <MobileScroll />
      <div class="table-wrap">
        <table class="national-table">
          <tr>
            <th>순번</th>
            <th>법안명</th>
            <th>제안일자</th>
            <th>소관위원회</th>
            <th>잠자는 시간</th>
          </tr>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <a class="link" :href="item.DETAIL_LINK" target="_blank">{{
                item.BILL_NAME
              }}</a>
            </td>
            <td>{{ item.PROPOSE_DT }}</td>
            <td>{{ item.COMMITTEE }}</td>
            <td class="red">{{ item.SLEEPING_DAY.toLocaleString() }}일</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MobileScroll from "../common/MobileScroll.vue";

export default {
  name: "CongressmanUnProcessing",

  components: { MobileScroll },

  props: {
    processingData: Array,
    sectedCongressman: String,
  },

  data() {
    return {
      data: [...this.processingData],
      isSortingListShow: false,
    };
  },

  watch: {
    processingData: function (_, newVal) {
      this.data = [...newVal];
    },
  },
};
</script>

<style scoped>
.national-blue-bar {
  width: 70px;
  height: 5px;
  display: inline-block;
  background-color: #005aab;
  margin-bottom: 19px;
  border-radius: 0 5px 5px 0;
}

.national-blue-bar.sky {
  background-color: #b0d6f8;
  margin-right: 5px;
}

.national-title {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #005aab;
}

.national-title .black {
  color: #000;
}

.link {
  color: #000;
  width: 100%;
  padding: 5px 0;
  display: inline-block;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
}

.national-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-collapse: collapse;
  overflow: hidden;
  border-radius: 10px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cacaca;
  min-width: 700px;

  & th {
    padding: 21px 0;
    border: 1px solid #cacaca;
    background-color: #005aab;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }
  & td {
    padding: 21px 0;
    border: 1px solid #cacaca;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    vertical-align: middle;
  }

  & tr td.red {
    color: #de0000;
  }

  & tr td.blue {
    color: #005aab;
  }
}

.national-table.sub-auto {
  table-layout: fixed;

  & .sky {
    background-color: #e7f4ff;

    & td {
      color: #005aab;
      width: auto !important;
      vertical-align: middle;
    }
  }

  & td {
    width: auto;
    max-width: 10px !important;
    vertical-align: middle;
  }

  & tr td:nth-child(n + 2) {
    width: 100px;
  }

  .not {
    width: auto !important;
  }
}

.prev-icon {
  margin-right: 10px;
}

.national-search-wrap {
  display: flex;
  width: 557px;
  height: 50px;
  border-radius: 10px;
  background-color: #e5e5e5;

  @media only screen and (max-width: 1040px) {
    margin: 0 30px;
    width: 100%;
    background-color: none;

    & .national-search-list {
      padding: 0;
      background-color: #e5e5e5;
    }

    & input {
      background-color: #e5e5e5;
    }

    & .national-search-btn {
      padding: 17px 10px 17px 10px;
      font-size: 12px;
    }

    & .national-search-btn img {
      width: 10px;
    }
  }
}

.title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 49px;
}

.national-search-list {
  line-height: 50px;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  border: solid 1px #d8d8d8;
  padding: 17px 20px 17px 31px;
  border-radius: 10px;
  display: inline-block;
  width: 197px;
  border-right: none;
  position: relative;
  cursor: pointer;
}

.search-input {
  width: 280px;
  background-color: transparent;
  border-top: solid 1px #d8d8d8;
  border-bottom: solid 1px #d8d8d8;
  border-left: solid 1px #d8d8d8;
  border-right: none;
}

.search-btn {
  width: 80px;
  height: 50px;
  border: solid 1px #004786;
  background-color: #005aab;
  border-radius: 0 10px 10px 0;

  &::placeholder {
    color: #989898;
    margin-left: 30px;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
}

.national-search {
  list-style: none;
  background-color: #fff;
  position: absolute;
  width: 100%;

  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  border: solid 1px #d8d8d8;
  padding: 0 20px 0 31px;
  border-radius: 10px;
  display: inline-block;
  width: 197px;
  top: 49px;
  left: -1px;
  padding-bottom: 19px;
  & li {
    margin-top: 19px;
    cursor: pointer;
  }

  & li:hover {
    color: #005aab;
  }
}

.national-button-wrap {
  display: flex;
  gap: 10px;
}

.prev-btn {
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  text-align: center;

  width: 199px;
  height: 50px;
  padding: 0 50px 0 30px;
  border-radius: 10px;
  border: solid 1px #0db2ab;
  background-color: #0db2ab;
  display: flex;
  align-items: center;

  &.mobile {
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    &.mobile {
      display: flex;
      margin: 0 auto 100px auto;
      width: 100%;
      border-radius: 0;
      font-size: 20px;
      gap: 10px;
      align-items: center;
      justify-content: center;
    }

    &.pc {
      display: none;
    }
  }
}

.sort-btn {
  width: 197px;
  height: 50px;
  border-radius: 10px;
  border: solid 1px #d8d8d8;
  background-color: #e5e5e5;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #121212;
  text-align: center;
  /* @todo 아이콘 받으면 간격 수정 */
}

.sort-wrap {
  position: relative;
}

.table-wrap {
  width: 100%;
  margin-bottom: 100px;
  overflow-x: scroll;
  padding: 1px;
}
</style>
